import { FC, useEffect, useMemo, useState } from 'react';
import { IconButton } from '@mui/material';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import FeedbackCard from 'src/pages/Van/components/Modal/HostModal/components/Feedback';
import { IVanHost } from 'src/store/reducers/host/types';
import './styles.scss';
import './media.scss';

interface IProps {
  host: IVanHost;
}

const Reviews: FC<IProps> = ({ host: { first_name, feedback } }) => {
  const isMobile = useMemo(() => window.outerWidth < 500, [window.outerWidth]);
  const [index, setIndex] = useState([0]);

  useEffect(() => {
    if (feedback.length > 1) setIndex([0, 1]);
    else setIndex([0]);
  }, [feedback]);

  const handleNext = () => {
    if (!feedback[index[0] + 1]) {
      setIndex([0, 1]);
    } else if (!feedback[index[1] + 1]) {
      setIndex([index[1], 0]);
    } else setIndex([index[0] + 1, index[0] + 2]);
  };

  const handlePrev = () => {
    if (!feedback[index[0] - 1]) {
      setIndex([feedback.length - 1, 0]);
    } else if (!feedback[index[1] - 1]) {
      setIndex([feedback.length - 2, index[0]]);
    } else setIndex([index[0] - 1, index[1] - 1]);
  };

  return (
    <>
      <div className='host-page-reviews__title'>
        {index.length > 1 && (
          <IconButton onClick={handlePrev}>
            <ArrowCircleLeftIcon fontSize='large' color='info' />
          </IconButton>
        )}
        <p>Here are {first_name}’s reviews.</p>
        {index.length > 1 && (
          <IconButton onClick={handleNext}>
            <ArrowCircleRightIcon fontSize='large' color='info' />
          </IconButton>
        )}
      </div>
      <div className='host-page-reviews__list'>
        {isMobile ? (
          <FeedbackCard feedback={feedback[index[0]]} />
        ) : (
          index.map((el, i) => <FeedbackCard feedback={feedback[el]} key={i} />)
        )}
      </div>
    </>
  );
};
export default Reviews;
